import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathUp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-path-up"><path d="M4.36309 8.94702C3.68147 9.76057 4.25989 10.9998 5.32124 10.9998H8.00002V18.2498C8.00002 20.3209 9.67896 21.9998 11.75 21.9998H12.25C14.3211 21.9998 16 20.3209 16 18.2498V10.9998H18.6788C19.7402 10.9998 20.3186 9.76057 19.637 8.94703L13.7247 1.89046C12.8254 0.817116 11.1746 0.817112 10.2754 1.89045L4.36309 8.94702Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowPathUp;
